import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@/lib/utils';

import LandingDropdown, { LandingDropdownOption } from './LandingDropdown';

const Flag = ({ country }: { country: 'gb' | 'es' | 'it' }) => (
  <img
    src={`https://flagcdn.com/w40/${country}.png`}
    alt=""
    width={22}
    height={16}
    className="h-4 w-[22px] rounded-[1px] object-cover"
  />
);

const LANGUAGE_OPTIONS: LandingDropdownOption[] = [
  { value: 'en', label: 'English', icon: <Flag country="gb" /> },
  { value: 'es', label: 'Spanish', icon: <Flag country="es" /> },
  { value: 'it', label: 'Italy', icon: <Flag country="it" /> }
];

const LandingLanguageSelector: React.FC = () => {
  const [language, setLanguage] = useState(LANGUAGE_OPTIONS[0].value);
  const selectedLanguage = LANGUAGE_OPTIONS.find((option) => option.value === language) ?? LANGUAGE_OPTIONS[0];

  return (
    <LandingDropdown
      align="end"
      options={LANGUAGE_OPTIONS}
      onSelect={setLanguage}
      trigger={(open) => (
        <button type="button" aria-expanded={open} aria-haspopup="menu" className="inline-flex items-center gap-2">
          {selectedLanguage.icon}
          <span className="sr-only">{selectedLanguage.label}</span>
          <ChevronDown
            className={cn('size-4 text-[#0A0A0A] transition-transform duration-200', open && 'rotate-180')}
          />
        </button>
      )}
    />
  );
};

export default LandingLanguageSelector;
